module.exports = __webpack_public_path__ + "static/media/amex.a187af91.svg";